var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.774,
    height: 26.821,
    viewBox: "0 0 26.774 26.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phoneSupport",
    d: "M18.447,6.224a5.9,5.9,0,0,1,4.665,4.665M18.447,1.5a10.628,10.628,0,0,1,9.388,9.377M26.655,20.3v3.543a2.362,2.362,0,0,1-2.574,2.362A23.371,23.371,0,0,1,13.889,22.58,23.028,23.028,0,0,1,6.8,15.494,23.371,23.371,0,0,1,3.177,5.255a2.362,2.362,0,0,1,2.35-2.574H9.07a2.362,2.362,0,0,1,2.362,2.031,15.163,15.163,0,0,0,.827,3.318,2.362,2.362,0,0,1-.531,2.492l-1.5,1.5a18.9,18.9,0,0,0,7.086,7.086l1.5-1.5a2.362,2.362,0,0,1,2.492-.531,15.163,15.163,0,0,0,3.318.827A2.362,2.362,0,0,1,26.655,20.3Z",
    transform: "translate(-2.167 -0.396)",
    fill: "none",
    stroke: "#5e2b97",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSupport);
export default __webpack_public_path__ + "static/media/phoneSupport.bc0311bee00a51272b3e72a81b72f3f0.svg";
export { ForwardRef as ReactComponent };